<template>
	<div class="m-charts m-module flex flex-grow" :class="{'flex-column': !horizontal}">
		<template v-for="(item, i) in dataList">
			<module v-if="item.hidden != 1" :key="i" :title="item.title" chart>
				<chart-line v-if="item.data_type == 1" :data="item.data"></chart-line>
				<chart-bar v-else-if="item.data_type == 2" :data="item.data"></chart-bar>
				<chart-pie v-else-if="item.data_type == 3" :data="item.data"></chart-pie>
				<chart-biax v-else-if="item.data_type == 4" :data="item.data" :field="item.count_fields_title"></chart-biax>
				<chart-col v-else-if="item.data_type == 5" :data="item.data"></chart-col>
			</module>
		</template>
	</div>
</template>

<script>
	import module from './digital_module.vue'
	import chartBiax from './chart_biax.vue'
	import chartBar from './chart_bar.vue'
	import chartLine from './chart_line.vue'
	import chartPie from './chart_pie.vue'
	import chartCol from './chart_col.vue'
	import {mapState} from 'vuex'

	export default {
		components: {
			module,
			chartBiax,
			chartBar,
			chartLine,
			chartPie,
			chartCol
		},

		props: {
			id: [Number, String],
			horizontal: Boolean
		},

		data() {
			return {
				dataList: []
			}
		},

		computed: {
			...mapState(['dictData'])
		},
		
		mounted() {
			this._updateTimer = [];
			this.update();
		},
		
		beforeDestroy() {
			for (let _timer of this._updateTimer) {
				clearTimeout(_timer);
			}
		},
		
		methods: {
			update(index) {
				this.request({
					url: '/digital/getData',
					data: {
						digital_id: this.$parent.digitalId,
						module_id: this.id
					},
					success: data => {
						data.childModuleList.forEach(chart => {
							if (chart.dimensional_type == 'PAGEDIC') {
								chart.data.forEach(item => {
									item.dimension_name = this.dictData[chart.dimensional_page_dic][item.dimension_name].name;
								})
							}
						});
						if (index === undefined) {
							data.childModuleList.forEach((chart, index) => {
								this._updateTimer[index] = setTimeout(() => {
									this.update(index);
								}, chart.refresh_time * 1000 || 300000);
							});
							this.dataList = data.childModuleList;
						} else {
							this.$set(this.dataList, index, data.childModuleList[index]);
							this._updateTimer[index] = setTimeout(() => {
								this.update(index);
							}, data.childModuleList[index].refresh_time * 1000 || 300000);
						}
					},
					fail: () => {
						if (index !== undefined) {
							this._updateTimer[index] = setTimeout(() => {
								this.update(index);
							}, 300000);
						}
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-charts {
		&.flex-column .module-box:nth-child(n+2) {
			margin-top: .15rem;
		}
		
		&:not(.flex-column) .module-box:nth-child(n+2) {
			margin-left: .15rem;
		}
	}
</style>
